<script>
export default {
    name: "transition-setting",
    props: {
        disabled: Boolean,
        value: {}
    },
    computed: {
        label() {
            return Lang.langChoice("Transition|Transitions", 1);

        },
        items() {
            return Object.values(Laravel.transitions);
        },
    }
}
</script>

<template>
    <v-autocomplete-custom
        :value="value"
        @input="$emit('input', $event)"
        :label="label"
        :disabled="disabled"
        :items="items"
    />
</template>
